import React, { FC } from "react";

import { DIGIPOSTHEME } from "theme/digiPosTheme";

import { TypographyProps } from "./Typography.contants";
import { BaseTypography } from "./Typography.styles";

const Typography: FC<TypographyProps> = ({
  children,
  className = "",
  variant = "p",
  size = "inherit",
  fontType = "helvetica",
  align = "left",
  weight,
  transform,
  disabled = false,
  decoration,
  color = DIGIPOSTHEME.colors.black,
  letterSpacing,
  margin,
  padding,
  width,
  height,
  wordBreak,
  backgroundColor,
  borderRadius,
  cursor,
  hoverColor,
  hoverDecoration,
  display,
}) => (
  <BaseTypography
    align={align}
    as={variant}
    backgroundColor={backgroundColor}
    borderRadius={borderRadius}
    className={className}
    color={color}
    cursor={cursor}
    decoration={decoration}
    disabled={disabled}
    fontType={fontType}
    hoverColor={hoverColor}
    hoverDecoration={hoverDecoration}
    letterSpacing={letterSpacing}
    margin={margin}
    padding={padding}
    size={size}
    transform={transform}
    weight={weight}
    width={width}
    height={height}
    wordBreak={wordBreak}
    display={display}
  >
    {children}
  </BaseTypography>
);

export default Typography;
